// c_prime-review.js
// 「選択してください」の文言を削除するScript

document.addEventListener('DOMContentLoaded', function () {
  function cleanPrimeReviewPlaceholder() {
    const form = document.querySelector('#mxpr-product-reviews-form');
    if (!form) return;

    const selects = form.querySelectorAll('select.mxpr-custom-field');

    selects.forEach((select) => {
      const firstOption = select.querySelector('option[value=""]');
      if (!firstOption) return;

      firstOption.textContent = firstOption.textContent
        .replace(/を選択してください/g, '')
        .trim();
    });
  }

  cleanPrimeReviewPlaceholder();
  setTimeout(cleanPrimeReviewPlaceholder, 500);
  setTimeout(cleanPrimeReviewPlaceholder, 1000);
  setTimeout(cleanPrimeReviewPlaceholder, 2000);
});